import { ChangeDetectionStrategy, Component } from "@angular/core";
@Component({
  selector: "retrieval-address-detail",
  templateUrl: "./address-detail.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressDetailComponent  { }
